import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import {EGoogleTagManagerEventSource, EGoogleTagManagerEventType} from '../../IGoogleTagManager';
import EventModel from '../EventModel';

/**
 * Represents SplashPageViewEventModel
 */
export default class SplashPageViewEventModel extends EventModel {
	public URI: string;
	public pageType: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		this.URI = data.uri;
		this.pageType = EGoogleTagManagerEventSource.SP;
		this.event = EGoogleTagManagerEventType.PAGE_VIEW;
	}

	/**
	 * Is independent event and should not wait for other
	 * @returns {boolean} is independent event
	 */
	public isIndependentEvent() {
		return true;
	}
};
